export default { 
	empty: 'Please input',
	fuzhicg: 'Success',
	fuzhicc: 'Error',
	error:{
		notNull: 'Not be NULL',
		notYes: 'Non-compliant'
	},
  login: { 
    signUp:'Giriş yap', 
    title: 'Tüm dijital varlıklarınız için evrensel cüzdan.', 
    submit: 'Giriş yap', 
    username: 'Lütfen telefon numaranızı girin', 
    password: 'Lütfen şifrenizi girin', 
    verifycode:'Lütfen captcha\'yı girin', 
    forget_password:'Parolanızı mı unuttunuz?', 
    no_account:'AuWallet hesabınız yok mu?', 
    register:'Kayıt ol', 
    verifycode_tip:'lütfen captcha\'yı girin', 
    verifycode_error:'Captcha yanlış ' 
  }, 
  register:{ 
    title:'Kayıt ol', 
    username:'Telefon numarası', 
    get_code:'Kodu Al', 
    verifycode:'Doğrulama kodu', 
    password:'Parola', 
    repeat:'Onayla', 
    invite_code:'Davet kodu', 
    submit:'Kayıt ol', 
    registered:'Böyle bir hesap zaten var', 
    go_login:'Giriş Yap' 
  }, 
  nologin:{ 
    cloud_wallet:'Cloud Cüzdanı', 
    cloud1:'En iyi güvenlik koruması', 
    cloud2:'Eşsiz varlık kazancı ve gelirin tadını çıkarmak için kayıt olun ve coinlerinizi yatırın', 
    cloud3:'30\'dan fazla popüler coin ve 500\'den fazla token\'i destekliyoruz', 
    button1:'Kayıt ol', 
    button2:'Giriş yap',
    button_oauth: '2U.Chat ile Giriş Yap',
    hd_wallet:'HD Wallet', 
    hd1:'Özel anahtarların %100 kontrolü, daha garantili varlıklar', 
    hd2:'Anımsatıcı kelimelerin tek tıklamayla içe aktarılması, kullanışlı ve kullanımı kolay', 
    hd3:'30\'dan fazla popüler coin ve 500\'den fazla token\'i destekliyoruz', 
    button3:'Kayıt ol', 
    button4:'Giriş yap', 
    doLogin:"Giriş yapmak için tıklayın",
    welcomeTo:"AuWallet'e Hoşgeldiniz",
  }, 
  forget:{ 
    title:'Parolanızı mı unuttunuz?', 
    phone_number:'Telefon numarası', 
    verify_code:'Doğrulama kodu', 
    password:'Parola', 
    repeat:'Tekrarla', 
    submit:'Onayla' 
  }, 
  footer:{ 
    nav1:'cüzdan', 
    nav2:'market', 
    nav3:'varlık', 
    nav4:'keşfet', 
    nav5:'benim' 
  }, 
  home:{ 
    total:'Toplam Varlıklar', 
    invite:'Arkadaşlarını davet et', 
    redbag:'Redpacket gönder', 
    exchange:'Al Sat', 
    scan:'Tara', 
    address_book:'Adres defteri', 
    notice:'Bildirimler', 
    setting:'Ayarlar', 
    view_mnemonic:'Anımsatıcıyı Görüntüle', 
    backup_mnemonic:'Anımsatıcıyı Yedekle', 
    create_wallet:'Cüzdan Oluştur', 
    import_wallet:'Cüzdanı İçe Aktar', 
    welcome:'Hoş geldin',
	cant9sale: 'KYC must pass level 2 or above and have never participated in a 10% discount event.'
  }, 
  
  address:{ 
    new_address:'Yeni adres', 
    name:'İsim', 
    address:'Adres', 
    submit:'Oluştur' ,
	warning_msg: 'Not: Bu adres sadece erc20 token alınabilir. Lütfen aktarılırken yanlış kanalı seçmeye dikkatli olun.'
  }, 
  swap:{ 
    title:'Flash Swap', 
    pay:'Ödemelisin', 
    balance:'Kalan bakiye', 
    lock_rate:'Bu kur üzerinden ödeme yapmak için lütfen ödemeyi aşağıdaki süre içinde tamamlayın', 
    gain:'Şu kadar alacaksınız ', 
    input:'Lütfen miktarı girin', 
    tip:'Aldığınız para biriminin boş olması flash swap yapacak para biriminin olmadığı anlamına gelir.', 
    submit:'Şimdi Swap Yap', 
    choose_coin:'Coin Seçin',
	notice_2ut: 'Bilgilendirmeyi okuduğumu onaylıyorum'
  },
  coin:{
    send:'Gönder',
    swap:'Swap',
    receive:'Al',
    transactions:'İşlemler',
    type1:'Cloud Gönderisi',
    type2:'Cloud Alımı',
    type3:'Swap',
    type4:'Finansal',
    type7:'HD Gönderisi',
    type8:'HD Alımı',
    type9:'Red Packet Gönder',
    type10:'Red Packet Kabul Et',
	type11:'AuWallet transfer out TimeEx',
	type12:'TimeEx transfer in AuWallet',
	type13: 'Chain shopping service fee',
	type14: '10% Off shopping service fee',
	type15: 'Withdrawal',
	type16: 'KYC Certification fees',
    flushing:'Yenileniyor...',
    loading:'Yükleniyor...',
    no_records:'Kayıt yok',
    wallet:' Cüzdan',
    tx_time:'İşlem Zamanı',
    tx_id:'ID',
    tx_from:'Kimden',
    tx_to:'Kime',
    tx_memo:'Açıklama',
    tx_status1:'başarısız oldu',
    tx_status2:'bekleniyor',
    tx_status3:'başarılı',
    tx_status4:'bekliyor',

    receive_address:'Lütfen işlem adresinizi giriniz',
    balance:'Bakiye',
    fee:'işlem ücreti',
    send_all:'Hepsini gönder',
    gas_fee:'Gas ücreti',
    slow:'yavaş',
    fast:'hızlı',
    send:'Gönder',
    tx_password:'Lütfen ödeme şifresini girin',
    tx_remark:'Açıklamalar (isteğe bağlı)',
    address_book1:'Cloud Adres Defteri',
    address_book2:'HD Adres Defteri',
    need_pay_pass:'Lütfen önce ödeme şifresini ayarlayın',
    need_pin:'Pin kodunu ayarlamak için lütfen profilinize gidin',

    
    set_receive_amount:'Alım miktarını ayarla',
    receive_amount:'Alma tutarı',
    copy_receive_code:'Ödeme kodunu kopyala',
    confirm:'Onayla',
    cancel:'İptal et',
    rcv_address:'Alım Adresi',
    search:'Arama içeriğini girin',
    filter:'Filtre',
    remove:'Sil',
    add:'Ekle',

    filter1:'Tüm varlıklar',
    filter2:'Eklendi',
    filter3:'Eklenmedi',
    
    notices:'HD Cüzdan Bildirimleri',
    notices2:'Cloud Cüzdan Bildirimleri',
	only_bitcoin: 'Burada sadece bitcoin transaksyonu',
	only_eth: 'Sadece ETH transaksyonu burada',
	only_usdt: 'Sadece USDT ERC20 aktarımı burada',
	only_2ut: 'Sadece 2UT aktarımı burada',
	only_u2u: 'Sadece u2u para',
	only_2u: 'Sadece 2U nokta',
	only_a2u: 'a2u onlu transfer',
	import: 'Import',
	info: 'Token overview'
  },

  market:{
    title:'Market',
    coin:'varlık',
    volume:'hacim',
    price:'fiyat',
    change:'değişim(24 Saat)',
  },

  discover:{
    title:'Keşfet',
    popular:'Popüler',
    all:'Hepsi'
  },

  my:{
    title:'Benim',
    notice:'Bildirimler',
    login:'Giriş yapmak için tıklayın ',
    welcome:'AuWallet\'a hoş geldiniz',
    invite:'Davet Ödülü',
    news:'Günlük Ekspres',
    contact:'Müşteri servisi',
    pin_on:'AÇIK',
    pin_off:'KAPALI',
    default_currency:'Varsayılan Para Birimi',
    red_green:'Teklif seçenekleri',
    option1:'Yeşil yukarı kırmızı aşağı',
    option2:'Kırmızı yukarı yeşil aşağı',
    contract:'Hizmet sözleşmesi',
    privacy:'Gizlilik Politikası',
    help:'Yardım Merkezi',
	invite: 'My Invite code',
	onequan: 'My Business Circle',
	copy: 'Copy',
	total: 'Total',
	downloadapp: 'Download mobile APP.',
	download: 'Download',
	waiting: 'Waiting Or Use',
	reenxv: 'GreenX Vcode',
	greenxvet: 'Can use'
  },
  setup:{
    title:'Cüzdan Ayarı',
    pay_password:'Ödeme Şifresi',
    on:'AÇIK',
    off:'KAPALI',
    google:'Google Doğrulaması',
    security_level:'Güvenlik Seviyesi',
    account_name:'Hesap adı',
    logout:'Çıkış Yap',
    register_time:'Kayıt Zamanı',
    level:'seviye',
    modify_pay_password:'Ödeme şifresini değiştir',
    reset_pay_password:'Ödeme şifresini sıfırla',
    reset_tip:'Hesap güvenliğiniz için lütfen ödeme şifrenizi giriniz',
    forget_pay_password:'Ödeme şifresini unuttum',
    set_pay_password:'Ödeme şifresi ayarla',
    enter_password:'Lütfen şifreyi giriniz',
    enter_password2:'Lütfen tekrar girin',
    vcode:'Doğrulama kodu',
    submit:'Onayla',
    pay_password_wrong:'Girdiğiniz ödeme şifresi hatalı',
    fontSize:'Yazı Boyutu'
  },
  news:{
    title:'Günlük Ekspres',
    share:'Paylaş',
    good:'İyi',
    bad:'Kötü',
  },

  pin:{
    title:'PIN kodunu ayarla',
    desc1:'Varlıklarınızın güvenliğini korumak için lütfen önce bir PIN kodu belirleyin, PIN kodu cüzdanın kilidini açmak ve varlık göndermek için kullanılacaktır.',
    desc2:'PIN kodu yerel bir paroladır, lütfen doğru şekilde saklayın, kaybolursa kurtarılamaz.',
    close:'PIN kodunu kapat',
    title2:'PIN\'i doğrulayın',
    tip2_1:'PIN kodunuzu mu unuttunuz? Cüzdanı yedekledikten sonra uygulamayı yeniden yükleyin ve anımsatıcı ifadeyi içe aktardıktan sonra sıfırlayın'
  },
  google:{
    title:'Google Doğrulaması',
    tip:'Google iki adımlı doğrulama, hesabınıza bir koruma katmanı ekleyebilir. Giriş yaptığınızda veya işlem yaptığınızda, şifrenizi girdikten sonra bir doğrulama koduna ihtiyacınız olacaktır.',
    help:'Google iki adımlı doğrulama nasıl kullanılır?',
  },
  security:{
    title:'Güvenlik seviyesi',
    title2:'Güvenlik seviyesi',
    tip:'Paranızın güvenliği için, para çekmeden önce daha fazla güvenlik ayarına ve gerçek ad bilgilerine ihtiyacınız var ve para çekme limitiniz buna göre artacaktır.',
    l3title:'Belge türünü seçin',
    l3tip:'Lütfen sertifikanızın verildiği ülkeyi seçin',
    c1:'ABD',
    c2:'Çin Anakarası',
    c3:'Çin Hong Kong, Makao ve Tayvan',
    c4:'Güney Kore',
    c5:'Japonya',
    c6:'Singapur',
    c7:'Diğer',
    nousdt: 'Your USDT balance is less than 3 and cannot undergo KYC authentication.',
  },
  realname:{
    title:'Sertifika Bilgileri',
    tip:'AuWallet, güvenlik doğrulamasını geçmek için devlet tarafından verilen bir fotoğraflı kimlik göndermenizi gerektirir.',
    subtitle1:'2U Token (2UT) Abonelik Formu',
    country:'Ülke',
    country_hint:'İkamet Ettiğiniz Ülke',
    firstname:'İlk adı',
    firstname_hint:'ilk adın',
    surname:'Soyadı',
    surname_hint:'Soyadın',
    birthdate:'Doğum günü',
    cert_id:'Kimlik Numarası ',
    cert_id_hint:'Kimlik Numaranız',
    id_photo1:'kimlik ön fotoğraf',
    id_photo2:'kimlik ters fotoğraf',
    address:'Adres',
    address_hint:'Mevcut ikametgahınız',
    addr_photo:'Adres kanıtı',
    asset_photo:'Varlıkların kanıtı',
    subtitle2:'Yatırımcı yeterlilik sertifikası',
    tip1:'Aşağıdaki kriterlerden en az birini karşıladığımı ve ihraççı tarafından nitelikli yatırımcı olarak belgelendiğimi onaylıyorum (varsa, birden fazla seçilebilir)',
    tip2:'Not (1): Yatırım portföyü, gayrimenkul hariç menkul kıymetler ve nakdi ifade etmektedir.',
    tip3:'Not (2): Son üç aya ait aylık ekstre, hesaplama özeti vb. içeren belgeler eklenmelidir.',
    invest_exp:'Yatırım deneyimi',
    other_exp:'Diğer',
    avg_volume:'Hacim',
    avg_volume_hint:'Son 12 aydaki ortalama işlem hacmi (USD)',
    avg_num:'Numara',
    avg_num_hint:'Son 12 aydaki ortalama işlem sayısı',
    exp_year:'Yatırım yılları',
    exp_year_hint:'Kaç yıllık yatırım tecrübesi',
    net_asset:'Net aktifler',
    net_asset_hint:'Net Aktif Değeri (ABD Doları)',
    risk_tolerance:'Risk toleransı',
    invest_term:'İdeal yatırım süresi',
    derivative:'türevler',
    signature:'İmza',
    reset:'Sıfırla',
    phone_number:'Telefon numarası',
    submit:'Göndermek',
    option1_1:'Eşleri veya çocukları ile ortak bir hesapta 20.000 ABD Doları (veya eşdeğeri) değerinden az olmayan nakit ve/veya menkul kıymet portföyü olan bireysel veya yüksek net değerli bireysel yatırımcılar',
    option1_2:'Şirketin veya ortaklığın yatırım portföyünün 20.000 ABD Dolarından az olmaması veya toplam varlıklarının 2 milyon ABD Dolarından az olmaması',
    option1_3:'Yüksek net değere sahip bireysel yatırımcılar veya şirketler veya ortaklıklar, De La O RuralBank Inc.\'de bir hesap açar ve bu değerlendirme formunu imzalarken 20.000 USD\'den az olmayan bir hesap açarlar.',
    option2_1:'menkul kıymetler',
    option2_2:'vadeli işlemler',
    option2_3:'yerleştirme',
    option2_4:'Diğer (Lütfen Belirtin)',
    option3_1:'Yüksek',
    option3_2:'Orta',
    option3_3:'Düşük',
    option4_1:'3 yıldan fazla',
    option4_2:'1-3 yıl',
    option4_3:'1 Yıldan az ',
    option5_1:'evet',
    option5_2:'hayır'
  },
  envelope:{
    title:'Kırmızı zarf',
    owned:'Zarflarım',
    amount:'Miktar',
    quantity:'Miktar',
    quantity_hint:'Zarf miktarı',
    generate:'üret',
    title2:'Zarf Gönder',
    total:'Kırmızı zarf toplam tutarı',
    wishes:'Dilekler',
    submit:'Ödemek',
    enter_pass:'Lütfen ödeme şifresini girin',
    choose_path:'Bir teslimat yöntemi seçin',
    view:'kırmızı zarf detayını görüntüle',
    choose_coin:'madeni para seçin',
    need_pay_password:'Lütfen önce ödeme şifresi belirleyin',
    share:'Kırmızı zarfı arkadaşlarınızla paylaşın',
    title3:'Kırmızı Zarf Kayıtları',
    num:'Miktar',
  },
  mnemonic:{
    title:'Yedek Cüzdan Anımsatıcı',
    tip:'Anımsatıcı, mülkünüzü kontrol etmenin anahtarı olan özel anahtardır.',
    tip1:'1. 12 karakterden oluşmaktadır, lütfen kopyalayıp güvenli bir yerde saklayınız.',
    tip2:'2. %100 sizin tarafınızdan tutulacaktır, bir kez kaybedildiğinde geri alınamaz.',
    tip3:'3. Lütfen para birimini almadan veya kaldırmadan önce anımsatıcı cümlenin yedeğini aldığınızdan emin olun.',
    backup:'Şimdi yedekle',
    later:'Sonra yap',
    tip4:'lütfen etrafına bak',
    tip5:'Anımsatıcıyı alan herkes, varlıklarınızı ele geçirdiği anlamına gelir. Lütfen etrafta kimsenin ve kamera olmadığından emin olun.',
    understand:'Anlaşıldı',     
    title2:'Anımsatıcıyı Görüntüle',
    tip6:'Diğer cihazlarda eşleştirmek için anımsatıcı ifadeyi içe aktarabilir veya eşleştirmek için QR kodunu taramak için diğer cihazlarda AuWallet cüzdanını kullanabilirsiniz.',
    tip7:'Lütfen ekran görüntüsü almayın! Birisi anımsatıcı ifadenizi alırsa, varlıklarınızı doğrudan alır!',
    view_code:'Şifreli QR kodunu görüntüleyin',
    tip8:'QR kodunu şifrelemek, cüzdanın yeni cihazlarla eşleşmesini kolaylaştırmaktır. Lütfen ekran görüntüsü alıp kaydetmeyin ve etrafta başka kimsenin veya gizli kamera olmadığından emin olun.',
    tip9:'Bu QR kodu yalnızca AU cüzdanları tarafından kullanılabilir. Tarama yaparken, ilgili anımsatıcıyı başarılı bir şekilde içe aktarmak için içe aktarılacak APP deki mevcut APP nin PIN kodunu girmeniz gerekir.',

    title3:'Lütfen AuWallet anımsatıcısını kopyalayın',
    tip3_1:'AuWallet anımsatıcı ifadesi, cüzdanı geri yüklemek için kullanılır. Lütfen aşağıdaki 12 kelimeyi kağıda sırayla kopyalayın ve güvenli bir yerde saklayın.',
    tip3_2:'Lütfen ekran görüntüsü almayın! Birisi anımsatıcı ifadenizi alırsa, varlıklarınızı doğrudan alır!',
    save:'güvenli bir şekilde kaydettim',

    title4:'Lütfen AuWallet anımsatıcı ifadesini onaylayın',
    tip4_1:'AuWallet anımsatıcı sözcüklerini doğru bir şekilde kopyaladığınızdan emin olmak için lütfen seri numarasına karşılık gelen sözcüğü seçin.',
    finish:'Bitti',
    next:'Sonraki',
    verror:'Anımsatıcı Cüzdanı Geri Yükle',

    title5:'Anımsatıcı Cüzdanı Geri Yükle',
    tip5_1:'Cüzdanı yanıtlamak için lütfen aşağıdaki forma anımsatıcı kelimeleri girin. Her anımsatıcı kelime girildikten sonra, bir sonraki kelimeye atlamak için "boşluk" tuşuna basın',
    recover:'Düzeltmeye başla',
    ask:'Mevcut cüzdanın üzerine yazılsın mı?',
    tip5_2:'Bir cüzdanı içe aktarmak, mevcut cüzdanın üzerine yazacaktır. Henüz yedeklemediyseniz, mevcut cüzdan sonsuza kadar kaybolacaktır.',
    tip5_3:'Mevcut cüzdanımı yedekledim ve üzerine yazmayı kabul ettim',
    cancel:'İptal',
    import:'İçe aktarmaya devam et',
    agree:'Lütfen kabul etmeyi seçin',
    create_success:'Başarıyla oluşturuldu',
    complete:'Lütfen tam anımsatıcıyı doldurun',
  },
  invite:{
    title:'Davetim',
    total:'davet numarası',
    invite_num:'Kayıtlı arkadaş sayısı',
    bonus1:'1 seviyeli arkadaşlar',
    every:'kişi başına',
    bonus2:'2 seviyeli arkadaşlar',
    bonus3:'3 seviyeli arkadaşlar',
    deposit:'Coin yatıran arkadaş sayısı',
    list:'davet listesi',
    subtitle1:'kayıt',
    subtitle2:'Depozito',
    no_records:'Henüz davetiye yok'
  },
  lang:{
    set_lang:'Dili ayarla',
  },
  setting:{
    tip:"Sistem aslında ABD doları ile işlem yapar ve sistem otomatik olarak kullanıcının komisyon fiyatını en son döviz kuru üzerinden ABD dolarına dönüştürür. Gerçek komisyon fiyatı, kullanıcının giriş fiyatından biraz farklı olabilir."
  },
  send:{
    title:'Transfer Türü',
    t1:'Blok Zinciri Transferi',
    t2:'İç transfer',
  },
  sortable:{
    title:'Özel Sıralama',
    drag_to_sort:'Sıralamak için sürükleyin',
    currency:'Para birimi'
  },
  system:{
    flushing:'Kızarma...',
    loading:'Yükleniyor...',
    btn1:'Teyit etmek',
    btn2:'İptal etmek',
    add:'Eklemek',
    search:'Aramak',
    topPullText:'Yenilemek için aşağıya çekin',
    topDropText:'Yenilemeyi bırak',
    topLoadingText:'Yükleniyor...',
    copy_succ:'Başarıyla kopyala',
    copy_fail:'Kopyalama başarısız',
    about:'About'
  },
  share:{ 
    title:'Paylaş', 
    download:'AuWallet\'i indirmek için kodu tarayın', 
    sharecode:'Davetiye kodu (kopyalamak için tıklayın):', 
    view_invites:'Davet ayrıntılarını görüntüle',
    copy_link:'Bağlantıyı kopyala',
    attention:"Yukarıdaki bağlantıyı kopyalayın, mobil tarayıcınıza yapıştırın ve AuWallet'ı indirmek için açın."
  }, 
  wealth:{
    tit:"Varlıklar",
    title:'Varlığım',
    title1:'Madencilik',
    title2:'Madeni para Planı',
    hot:'Popüler öneri',
    plan1:'İsteğe bağlı plan',
    plan2:'Sabit plan',
    annu_return:'yıllık getiri',
    in_amount:'miktar',
    transfer_all:'Tümü',
    view_rules:'kuralları görüntüle',
    pay_password:'Lütfen ödeme şifresini girin',
    asset:'Varlık',
    search:'İşlem sorgulama',
    rules:'kurallar',
    order_time:'sipariş zamanı',
    value_date:'değer tarihi',
    expiry_date:'Son kullanma tarihi',
    highlights:'öne çıkanlar',
    remaining_quota:'kalan kota',
    buy:'Şimdi satın al',
    ystday_earnings:"dünkü kazanç",
    total_earnings:'toplam kazanç',
    transfer_in:'içinde',
    transfer_out:'dışında',
	transfer_outed:'Yeniden taşındı',
    tran_all:'tümü',
    tran_in:'içinde',
    tran_out:'dışında',
    tran_earning:'gelir elde etmek',
    prod_all:'tümü',
    prod1:'PoS Madenciliği',
    prod2:'Madeni para Planı',
    curr_all:'tümü',
    out_amount_tip:'Lütfen transfer tutarını girin',
    send:'Gönder',
    success:'başarı',
    amount_tip:'Lütfen bir miktar girinc',
  },
  ads:{
    title:'İyi haberler',
    content:'STO stok U2U sıcak satış',
    content2:'STO stok 2UT sıcak satış',
    buy:'satın almak',
    plan_name:'U2U Yeni Hisse İhracı',
    tip: 'U2U is 10% off!'
  },
  buyuut: {
    maxtip: 'Each person can buy a maximum of 100',
    current: 'Current',
    price: 'Price',
    discount: 'Discount',
    off: 'OFF',
    amountlabel: 'Purchase quantity',
    maxerror: 'You can\'t buy more than 100',
    totalprice: 'Total Price',
    balance: 'Balance',
    purchase: 'Purchase',
    rulestitle: 'Rules of Activity'
  },
  receive:{
	  fuzhicg:'Başarılı anladım.',
	  fuzhicc:'Kopyalama başarısız oldu.',
  },
  alert:{
  	  cancel:'iptal et',
  	  confirm:'onaylayın'
  },
  against:{
		  no100: "Usdt, 100'den çoklu olmalı."
	},
	package:{
		  title: 'Paket',
		  amount: 'Kıymet',
		  time: 'Zaman',
		  coin: 'Token',
		  price: 'Price',
		  scale: 'Ölçü',
		  quantity: 'Kıymet',
		  submit: 'Teslim et',
		  total: 'Toplam',
		  points: 'Doğru',
		  apoints2: 'Available income of wealth',
		  balance: 'Balans',
		  apoints: 'Mevcut Noktalar:',
		  abalance: 'Available balance(USDT):',
		  abalance2: 'Available balance(U2U):',
		  import: 'İçeri',
		  orders: 'Emirler',
		  orders_detail: 'Sıra detayları',
		  defi: 'DEFI',
		  nopoint: 'Mevcut noktalardan fazlasını azaltın',
		  nobalance: 'Kıskandırma ulaşılabilir dengelendir',
		  nologin: 'Login has expired, please login again.',
		  pay_type: 'Ödeme türü'
	},
	nasdaq:{
		  label :'(IPO)Stock pre purchase application',
		  label2 :'Number of (IPO)stock exchange applications',
		  apply :'Apply',
		  applyed :'Applied',
		  background :'Background Description',
		  text :'1. The formal plan must meet the requirements that the NASDAQ stock reform documents submitted by (relevant stocks) are received and entered into the countdown process for submission.<br />2. During the official review process of NASDAQ (related stocks), there is no rule out the possibility of rejection or extension of time.',
		  cancel: 'Cancel',
		  submit: 'Submit',
	},
	ysjjy: "(Based on actual transactions)"
}
